import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { useSession } from '../../providers/SessionProvider';
import { REACT_APP_AWS_BUCKET_PATH } from '../../utils/config';

function AgentImage({ agent }) {
  const image_uri = `${process.env.REACT_APP_API_URI}/agents/avatars/${agent.profile_image}`;
  return (
    <img
      src={
        agent.profile_image
          ? `${REACT_APP_AWS_BUCKET_PATH}/uploads/agents/images/${agent.profile_image}`
          : 'https://via.placeholder.com/150'
      }
      width="141"
      height="137"
      alt={agent.name}
    />
  );
}

function ContentHeader() {
  const { agent, doLogout } = useSession();

  const handleLogout = useCallback(e => {
    e.preventDefault();
    doLogout();
  }, []);

  return (
    <div className="header-content">
      <div className="user">
        <div className="dados">
          <i className="foto">
            <AgentImage agent={agent} />
          </i>
          <span>{agent.name}</span>
        </div>
        <div className="bubble sub-user">
          <p>
            <a href="/" onClick={e => handleLogout(e)}>
              Sair
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ContentHeader;
